const prefixApps = '/apps/';

export const AppSettings = {
    AUTO_HIDE_DELAY: process.env.REACT_APP_AUTO_HIDE_DELAY,
    UI_SIZE: process.env.REACT_APP_UI_SIZE,
    DEBUG: process.env.REACT_APP_DEBUG
};

export const AppErrors = {
    Axios:{
        "0000" : "error",
        "1001" : "duplicate",
    }
};

/** handle pages : title, icon, breadcrumbs, toolbar for each page */
export const AppProps = {

    "register" : {
        title: '',
        icon: 'fa-classic fa-light fa-street-view fa-fw',
        breadcrumbs: [],     
        toolbar: {
            display: true,
            toolbars: {
                search: false,
                refresh: false,
                delete: false,
                new: true
            }
        }   
    },
    "type-a-duol-coop" : {
        title: 'ข้อมูลนักศึกษา ทวิภาคี',
        icon: 'fa-classic fa-light fa-street-view fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type A',
                path: '',
            },
            {
                label: 'ข้อมูลนักศึกษา ทวิภาคี',
                path: prefixApps + 'type-a-duol-coop',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "type-a-student" : {
        title: 'ข้อมูลนักศึกษา 100%',
        icon: 'fa-classic fa-light fa-street-view fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type A',
                path: '',
            },
            {
                label: 'ข้อมูลนักศึกษา 100%',
                path: prefixApps + 'type-a-student',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "type-a-student-import-file" : {
        title: 'นำเข้าไฟล์',
        icon: 'fa-classic fa-light fa-cloud-arrow-up fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type A',
                path: '',
            },
            {
                label: 'นำเข้าไฟล์',
                path: prefixApps + 'type-a-student-import-file',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "type-a-100-new-student-import-file" : {
        title: 'นักศึกษาใหม่ 100%',
        icon: 'fa-classic fa-light fa-cloud-arrow-up fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type A',
                path: '',
            },
            {
                label: 'นักศึกษาใหม่ 100%',
                path: prefixApps + 'type-a-100-new-student-import-file',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "type-a-100-grad-student-import-file" : {
        title: 'ผู้สำเร็จการศึกษา 100%',
        icon: 'fa-classic fa-light fa-cloud-arrow-up fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type A',
                path: '',
            },
            {
                label: 'ผู้สำเร็จการศึกษา 100%',
                path: prefixApps + 'type-a-100-grad-student-import-file',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "type-a-statistic-new-student-import-file" : {
        title: 'นักศึกษาใหม่ ทวิภาคี',
        icon: 'fa-classic fa-light fa-cloud-arrow-up fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type A',
                path: '',
            },
            {
                label: 'นักศึกษาใหม่ ทวิภาคี',
                path: prefixApps + 'type-a-statistic-new-student-import-file',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "type-a-statistic-grad-student-import-file" : {
        title: 'ผู้สำเร็จการศึกษา ทวิภาคี',
        icon: 'fa-classic fa-light fa-cloud-arrow-up fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type A',
                path: '',
            },
            {
                label: 'ผู้สำเร็จการศึกษา ทวิภาคี',
                path: prefixApps + 'type-a-statistic-grad-student-import-file',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    /** 
    "type-a-benefits-received" : {
        title: 'ข้อมูลนักศึกษา',
        icon: 'fa-classic fa-light fa-user-plus fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type A',
                path: '',
            },
            {
                label: 'ข้อมูลนักศึกษา',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'สวัสดิการที่ได้รับ',
                path: prefixApps + 'type-a-benefits-received',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb01-course-list" : {
        title: 'หลักสูตร',
        icon: 'fa-classic fa-light fa-list-check fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'หลักสูตร',
                path: prefixApps + 'eb01-course-list',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    */
    "eb-import-course" : {
        title: 'นำเข้าข้อมูลหลักสูตร Type B',
        icon: 'fa-classic fa-light fa-grid-2-plus fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'นำเข้าข้อมูลหลักสูตร Type B',
                path: prefixApps + 'eb-import-course',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb01-course" : {
        title: 'ขอพิจารณารับรองหลักสูตร',
        icon: 'fa-classic fa-light fa-grid-2-plus fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'ขอพิจารณารับรองหลักสูตร',
                path: prefixApps + 'eb01-course',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb01-expenses-eb01" : {
        title: 'ค่าใช้จ่าย',
        icon: 'fa-classic fa-regular fa-message-dollar fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'ขอพิจารณารับรองหลักสูตร',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ค่าใช้จ่าย',
                path: prefixApps + 'eb01-expenses-eb01',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },    
    "eb01-learning-result" : {
        title: 'ผลลัพธ์การเรียนรู้ของหลักสูตร',
        icon: 'fa-classic fa-regular fa-chart-sine fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'ขอพิจารณารับรองหลักสูตร',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ผลลัพธ์การเรียนรู้ของหลักสูตร (Learning Outcomes)',
                path: prefixApps + 'eb01-learning-result',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb01-course-benefit" : {
        title: 'ผลกระทบและประโยชน์ที่คาดว่าจะได้รับ (Impact)',
        icon: 'fa-classic fa-regular fa-stars fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'ขอพิจารณารับรองหลักสูตร',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ผลกระทบและประโยชน์ที่คาดว่าจะได้รับ (Impact)',
                path: prefixApps + 'eb01-course-benefit',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb01-training-details" : {
        title: 'รายละเอียดการฝึกอบรม',
        icon: 'fa-classic fa-regular fa-person-chalkboard fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'ขอพิจารณารับรองหลักสูตร',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'รายละเอียดการฝึกอบรม',
                path: prefixApps + 'eb01-training-details',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb02-course" : {
        title: 'ขออนุมัติจัดอบรม',
        icon: 'fa-classic fa-light fa-chalkboard-user fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'ขออนุมัติจัดอบรม',
                path: prefixApps + 'eb02-course',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb02-training-details" : {
        title: 'รายละเอียดการฝึกอบรม',
        icon: 'fa-classic fa-regular fa-person-chalkboard fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'ขออนุมัติจัดอบรม',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'รายละเอียดการฝึกอบรม',
                path: prefixApps + 'eb02-training-details',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb02-training-details-enterprise" : {
        title: 'ผู้ประกอบการ',
        icon: 'fa-classic fa-light fa-house-building fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'ขออนุมัติจัดอบรม',
                path: '',
            },            
            {
                label: 'รายละเอียดการฝึกอบรม',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ผู้ประกอบการ',
                path: prefixApps + 'eb02-training-details-enterprise',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb02-expenses-eb02" : {
        title: 'ค่าใช้จ่าย',
        icon: 'fa-classic fa-light fa-circle-dollar fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'ขออนุมัติจัดอบรม',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ค่าใช้จ่าย',
                path: prefixApps + 'eb02-expenses-eb02',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb03-course" : {
        title: 'รายงานผลการจัดอบรม',
        icon: 'fa-classic fa-light fa-square-poll-horizontal fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'รายงานผลการจัดอบรม',
                path: prefixApps + 'eb03-course',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb03-training-details" : {
        title: 'รายละเอียดการจัดอบรม',
        icon: 'fa-classic fa-regular fa-person-chalkboard fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'รายงานผลการจัดอบรม',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'รายละเอียดการจัดอบรม',
                path: prefixApps + 'eb03-training-details',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb03-training-details-enterprise" : {
        title: 'ผู้ประกอบการ',
        icon: 'fa-classic fa-light fa-house-building fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'รายงานผลการจัดอบรม',
                path: '',
            },            
            {
                label: 'รายละเอียดการจัดอบรม',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ผู้ประกอบการ',
                path: prefixApps + 'eb03-training-details-enterprise',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb04-certification" : {
        title: 'เอกสารรับรองจากสถานประกอบการ',
        icon: 'fa-classic fa-light fa-certificate fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'รายงานผลการจัดอบรม',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'เอกสารรับรองจากสถานประกอบการ',
                path: prefixApps + 'eb04-certification',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb04-certification-training-lists" : {
        title: 'ผู้เข้าอบรม',
        icon: 'fa-classic fa-light fa-address-card fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'รายงานผลการจัดอบรม',
                path: '',
            },
            {
                label: 'เอกสารรับรองจากสถานประกอบการ',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ผู้เข้าอบรม',
                path: prefixApps + 'eb04-certification-training-lists',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb05-satisfaction-assessment" : {
        title: 'แบบประเมินความพึงพอใจคุณภาพของหลักสูตร',
        icon: 'fa-classic fa-light fa-message-check fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'รายงานผลการจัดอบรม',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'แบบประเมินความพึงพอใจคุณภาพของหลักสูตร',
                path: prefixApps + 'eb05-satisfaction-assessment',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eb04-course" : {
        title: 'ผลการอบรม',
        icon: 'fa-classic fa-light fa-square-poll-horizontal fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'EEC Model Type B',
                path: '',
            },
            {
                label: 'ผลการอบรม (EB04)',
                path: prefixApps + 'eb04-course',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "demand-manpower" : {
        title: 'ความต้องการกำลังคน',
        icon: 'fa-classic fa-light fa-people-group fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ความต้องการกำลังคน',
                path: '',
            },
            {
                label: 'ความต้องการกำลังคน',
                path: prefixApps + 'demand-manpower',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "demand-manpower-skills-set" : {
        title: 'ทักษะ Skills Set',
        icon: 'fa-classic fa-light fa-star-shooting fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ความต้องการกำลังคน',
                path: '',
            },
            {
                label: 'ความต้องการกำลังคน',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ทักษะ Skills Set',
                path: prefixApps + 'demand-manpower-skills-set',
                parameters: []
            }            
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "supply-human-resource" : {
        title: 'ผลผลิตกำลังคน',
        icon: 'fa-classic fa-light fa-head-side-gear fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ความต้องการกำลังคน',
                path: '',
            },
            {
                label: 'ผลผลิตกำลังคน',
                path: prefixApps + 'supply-human-resource',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "supply-human-resource-in-out" : {
        title: 'นักศึกษา',
        icon: 'fa-classic fa-light fa-graduation-cap fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ความต้องการกำลังคน',
                path: '',
            },
            {
                label: 'ผลผลิตกำลังคน',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'นักศึกษา',
                path: prefixApps + 'supply-human-resouce-in-out',
                parameters: []
            }            
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },    
    "supply-human-resource-skills-set" : {
        title: 'ทักษะ Skills Set',
        icon: 'fa-classic fa-light fa-star-shooting fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ความต้องการกำลังคน',
                path: '',
            },
            {
                label: 'ผลผลิตกำลังคน',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ทักษะ Skills Set',
                path: prefixApps + 'supply-human-resouce-skills-set',
                parameters: []
            }            
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    }, 
    "supply-human-resource-industries" : {
        title: 'อุตสาหกรรม',
        icon: 'fa-classic fa-light fa-building-circle-check fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ความต้องการกำลังคน',
                path: '',
            },
            {
                label: 'ผลผลิตกำลังคน',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'อุตสาหกรรม',
                path: prefixApps + 'supply-human-resouce-industries',
                parameters: []
            }            
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },   
    "matching-demand-supply" : {
        title: 'จับคู่ความต้องการกำลังคน',
        icon: 'fa-classic fa-light fa-link fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ความต้องการกำลังคน',
                path: '',
            },
            {
                label: 'จับคู่ความต้องการกำลังคน',
                path: prefixApps + 'matching-demand-supply',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: false,
                new: false
            }
        }   
    },  
    "public-data-publicize-news" : {
        title: 'ข่าวสาร',
        icon: 'fa-classic fa-light fa-message-lines fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ประชาสัมพันธ์',
                path: '',
            },
            {
                label: 'ข่าวสาร',
                path: prefixApps + 'public-data-publicize-news',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "public-data-publicize-academy-and-course" : {
        title: 'สถาบันและหลักสูตร',
        icon: 'fa-classic fa-light fa-scroll fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ประชาสัมพันธ์',
                path: '',
            },
            {
                label: 'สถาบันและหลักสูตร',
                path: prefixApps + 'public-data-publicize-academy-and-course',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "public-data-publicize-vacancies" : {
        title: 'ประชาสัมพันธ์ตำแหน่งงาน',
        icon: 'fa-classic fa-light fa-business-time fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ประชาสัมพันธ์',
                path: '',
            },
            {
                label: 'ประชาสัมพันธ์ตำแหน่งงาน',
                path: prefixApps + 'public-data-publicize-vacancies',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "public-data-publicize-news-list" : {
        title: 'ข้อมูลข่าวสาร',
        icon: 'fa-classic fa-light fa-message-lines fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ประชาสัมพันธ์',
                path: '',
            },
            {
                label: 'ข้อมูลข่าวสาร',
                path: prefixApps + 'public-data-publicize-news-list',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "public-data-publicize-academy-and-course-list" : {
        title: 'ข้อมูลสถาบันและหลักสูตร',
        icon: 'fa-classic fa-light fa-scroll fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ประชาสัมพันธ์',
                path: '',
            },
            {
                label: 'ข้อมูลสถาบันและหลักสูตร',
                path: prefixApps + 'public-data-publicize-academy-and-course-list',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "public-data-publicize-vacancies-list" : {
        title: 'ข้อมูลประชาสัมพันธ์ตำแหน่งงาน',
        icon: 'fa-classic fa-light fa-business-time fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ประชาสัมพันธ์',
                path: '',
            },
            {
                label: 'ข้อมูลประชาสัมพันธ์ตำแหน่งงาน',
                path: prefixApps + 'public-data-publicize-vacancies-list',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eec-nets-data" : {
        title: 'ศูนย์เครือข่าย',
        icon: 'fa-classic fa-light fa-chart-network fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ศูนย์เครือข่าย',
                path: prefixApps + 'eec-nets-data',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eec-nets-data-mission" : {
        title: 'ภารกิจ',
        icon: 'fa-classic fa-light fa-flag fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ศูนย์เครือข่าย',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ภารกิจ',
                path: prefixApps + 'eec-nets-data-mission',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "eec-nets-data-operation" : {
        title: 'การดำเนินงานของศูนย์',
        icon: 'fa-classic fa-light fa-pen-line fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ศูนย์เครือข่าย',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'การดำเนินงานของศูนย์',
                path: prefixApps + 'eec-nets-data-operation',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },   
    "eec-nets-data-performance" : {
        title: 'ผลการดำเนินงานของศูนย์ที่ผ่านมา',
        icon: 'fa-classic fa-light fa-chart-line-up fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ศูนย์เครือข่าย',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ผลการดำเนินงานของศูนย์ที่ผ่านมา',
                path: prefixApps + 'eec-nets-data-performance',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    }, 
    "eec-nets-data-future-plans" : {
        title: 'แผนการดำเนินงานในอนาคต',
        icon: 'fa-classic fa-light fa-calendar-lines-pen fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ศูนย์เครือข่าย',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'แผนการดำเนินงานในอนาคต',
                path: prefixApps + 'eec-nets-data-future-plans',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    }, 
    "eec-nets-data-partner" : {
        title: 'หน่วยงานพันธมิตรของศูนย์',
        icon: 'fa-classic fa-light fa-handshake fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ศูนย์เครือข่าย',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'หน่วยงานพันธมิตรของศูนย์',
                path: prefixApps + 'eec-nets-data-partner',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },  
    "eec-nets-data-attach" : {
        title: 'ภาพประกอบ',
        icon: 'fa-classic fa-light fa-image fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ศูนย์เครือข่าย',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ภาพประกอบ',
                path: prefixApps + 'eec-nets-data-attach',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "common-data-enterprise" : {
        title: 'ผู้ประกอบการ',
        icon: 'fa-classic fa-light fa-house-building fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ผู้ใช้และระดับสิทธิ์',
                path: '',
            },
            {
                label: 'ผู้ประกอบการ',
                path: prefixApps + 'common-data-enterprise',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "common-data-academy" : {
        title: 'สถานศึกษา',
        icon: 'fa-classic fa-light fa-place-of-worship fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ผู้ใช้และระดับสิทธิ์',
                path: '',
            },
            {
                label: 'สถานศึกษา',
                path: prefixApps + 'common-data-academy',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "user-data-external-user" : {
        title: 'ผู้ใช้งานภายนอก',
        icon: 'fa-classic fa-light fa-people-pants-simple fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ผู้ใช้และระดับสิทธิ์',
                path: '',
            },
            {
                label: 'ผู้ใช้งานภายนอก',
                path: prefixApps + 'user-data-external-user',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "user-data-external-user-work-history" : {
        title: 'ประวัติการทำงาน',
        icon: 'fa-classic fa-regular fa-clock-rotate-left fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ผู้ใช้และระดับสิทธิ์',
                path: '',
            },
            {
                label: 'ผู้ใช้งานภายนอก',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ประวัติการทำงาน',
                path: prefixApps + 'user-data-external-user-work-history',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "user-data-external-user-training-history" : {
        title: 'ประวัติการฝึกอบรม',
        icon: 'fa-classic fa-regular fa-screen-users fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ผู้ใช้และระดับสิทธิ์',
                path: '',
            },
            {
                label: 'ผู้ใช้งานภายนอก',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ประวัติการฝึกอบรม',
                
                path: prefixApps + 'user-data-external-user-training-history',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "user-data-external-user-skills-set" : {
        title: 'ทักษะ (Skill set)',
        icon: 'fa-classic fa-regular fa-clock-rotate-left fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ผู้ใช้และระดับสิทธิ์',
                path: '',
            },
            {
                label: 'ผู้ใช้งานภายนอก',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ทักษะ (Skill set)',
                path: prefixApps + 'user-data-external-user-skills-set',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "user-data-user" : {
        title: 'ผู้ใช้งาน',
        icon: 'fa-classic fa-light fa-user-group-simple fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ผู้ใช้และระดับสิทธิ์',
                path: '',
            },
            {
                label: 'ผู้ใช้งาน',
                path: prefixApps + 'user-data-user',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },    
    "user-data-permission" : {
        title: 'สิทธิ์การเข้าใช้งาน',
        icon: 'fa-classic fa-light fa-gears fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ผู้ใช้และระดับสิทธิ์',
                path: '',
            },
            {
                label: 'สิทธิ์การเข้าใช้งาน',
                path: prefixApps + 'user-data-permission',
                parameters: []
            }
        ],     
        toolbar: {
            display: false,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },

    "prototype-template" : {
        title: 'Prototype Template',
        icon: 'fa-classic fa-light fa-wand-magic-sparkles fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'Prototype Template',
                path: prefixApps + 'prototype-template',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-region" : {
        title: 'ภูมิภาค',
        icon: 'fa-classic fa-light fa-map-location-dot fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'พื้นที่',
                path: '',
            },
            {
                label: 'ภูมิภาค',
                path: prefixApps + 'master-data-region',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-province" : {
        title: 'จังหวัด',
        icon: 'fa-classic fa-light fa-location-arrow fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'ภูมิภาค',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'จังหวัด',
                path: prefixApps + 'master-data-province',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-district" : {
        title: 'อำเภอ',
        icon: 'fa-classic fa-light fa-location-dot fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'ภูมิภาค',
                path: '',
            },
            {
                label: 'จังหวัด',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'อำเภอ',
                path: prefixApps + 'master-data-district',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-subdistrict" : {
        title: 'ตำบล',
        icon: 'fa-classic fa-light fa-map-pin fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'ภูมิภาค',
                path: '',
            },
            {
                label: 'จังหวัด',
                path: '',
            },
            {
                label: 'อำเภอ',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ตำบล',
                path: prefixApps + 'master-data-subdistrict',
                parameters: []
            },
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-prefix-name" : {
        title: 'คำนำหน้าชื่อ',
        icon: 'fa-classic fa-light fa-user-tag fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'คำนำหน้าชื่อ',
                path: prefixApps + 'master-data-prefix-name',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-position" : {
        title: 'ตำแหน่ง',
        icon: 'fa-classic fa-light fa-users fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'ตำแหน่ง',
                path: prefixApps + 'master-data-position',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-target-industries" : {
        title: 'อุตสาหกรรมเป้าหมาย',
        icon: 'fa-classic fa-light fa-building-circle-check fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'อุตสาหกรรมเป้าหมาย',
                path: prefixApps + 'master-data-target-industries',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "common-data-skills-set-type" : {
        title: 'ประเภททักษะ Skills Set',
        icon: 'fa-classic fa-light fa-stars fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'ประเภททักษะ Skills Set',
                path: prefixApps + 'common-data-skills-set-type',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "common-data-skills-set" : {
        title: 'ทักษะ Skills Set',
        icon: 'fa-classic fa-light fa-star-shooting fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'ประเภททักษะ Skills Set',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'ทักษะ Skills Set',
                path: prefixApps + 'common-data-skills-set',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },    
    "common-data-skills-set-cluster" : {
        title: 'Cluster Skills Set',
        icon: 'fa-classic fa-light fa-star-shooting fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'Custer Skills Set',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'Cluster Skills Set',
                path: prefixApps + 'common-data-skills-set-cluster',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-expense-category" : {
        title: 'หมวดค่าใช้จ่าย',
        icon: 'fa-classic fa-light fa-comment-dollar fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'หมวดค่าใช้จ่าย',
                path: prefixApps + 'master-data-expense-category',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-welfare" : {
        title: 'สวัสดิการ',
        icon: 'fa-classic fa-light fa-hand-holding-circle-dollar fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'สวัสดิการ',
                path: prefixApps + 'master-data-welfare',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-benefits" : {
        title: 'สิทธิประโยชน์',
        icon: 'fa-classic fa-light fa-hands-holding-dollar fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'สิทธิประโยชน์',
                path: prefixApps + 'master-data-benefits',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-education-type" : {
        title: 'ประเภทสถานศึกษา',
        icon: 'fa-classic fa-light fa-school fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'ประเภทสถานศึกษา',
                path: prefixApps + 'master-data-education-type',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-education-level" : {
        title: 'ระดับการศึกษา',
        icon: 'fa-classic fa-light fa-graduation-cap fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'ระดับการศึกษา',
                path: prefixApps + 'master-data-education-level',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-faculty" : {
        title: 'คณะ',
        icon: 'fa-classic fa-light fa-layer-group fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'คณะ',
                path: prefixApps + 'master-data-faculty',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-department" : {
        title: 'สาขาวิชา',
        icon: 'fa-classic fa-light fa-timeline fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'คณะ',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'สาขาวิชา',
                path: prefixApps + 'master-data-department',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-department-work" : {
        title: 'สาขางาน',
        icon: 'fa-classic fa-light fa-split fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'คณะ',
                path: '',
            },
            {
                label: 'สาขาวิชา',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'สาขางาน',
                path: prefixApps + 'master-data-department-work',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-education-area" : {
        title: 'เขตพื้นที่การศึกษา',
        icon: 'fa-classic fa-light fa-signs-post fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'เขตพื้นที่การศึกษา',
                path: prefixApps + 'master-data-education-area',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-ministry" : {
        title: 'สังกัดกระทรวง',
        icon: 'fa-classic fa-light fa-synagogue fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'โครงสร้างหน่วยงาน',
                path: '',
            },
            {
                label: 'สังกัดกระทรวง',
                path: prefixApps + 'master-data-ministry',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-office-department" : {
        title: 'สังกัดงาน / กรม',
        icon: 'fa-classic fa-light fa-building-flag fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'โครงสร้างหน่วยงาน',
                path: '',
            },
            {
                label: 'สังกัดกระทรวง',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'สังกัดสำนักงาน / กรม',
                path: prefixApps + 'master-data-office-department',
                parameters: []
            }
        ],     
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
    "master-data-office-division" : {
        title: 'สังกัดสำนัก / กอง',
        icon: 'fa-classic fa-light fa-poll-people fa-fw',
        breadcrumbs: [
            {
                label: 'Dashboard',
                path: '/dashboard',
            },
            {
                label: 'ข้อมูลพื้นฐาน',
                path: '',
            },
            {
                label: 'โครงสร้างหน่วยงาน',
                path: '',
            },
            {
                label: 'สังกัดกระทรวง',
                path: '',
            },
            {
                label: 'สังกัดสำนักงาน / กรม',
                path: '',
                parameters: [],
                onClick: (parentInstance) => { parentInstance.backward(); }
            },
            {
                label: 'สังกัดสำนัก / กอง',
                path: prefixApps + 'master-data-office-division',
                parameters: []
            }
        ],    
        toolbar: {
            display: true,
            toolbars: {
                search: true,
                refresh: true,
                delete: true,
                new: true
            }
        }   
    },
}

/** handle button properties */
export const ButtonProps = {
    "new" : {
        variant: 'primary',
        icon: 'fa-classic fa-light fa-circle-check fa-fw',
        label: 'บันทึก',
    },
    "new-register" : {
        variant: 'primary',
        icon: 'fa-classic fa-light fa-circle-check fa-fw',
        label: 'ลงทะเบียนผู้ใช้',
    },
    "update" : {
        variant: 'primary',
        icon: 'fa-classic fa-light fa-pen-to-square fa-fw',
        label: 'ปรับปรุง',
    },
    "new-no-text" : {
        variant: 'primary',
        icon: 'fa-classic fa-light fa-floppy-disk fa-fw',
        label: '',
    },
    "update-no-text" : {
        variant: 'primary',
        icon: 'fa-classic fa-light fa-pen-to-square fa-fw',
        label: '',
    },    
    "discard" : {
        variant: 'secondary',
        icon: 'fa-classic fa-light fa-circle-xmark fa-fw',
        label: 'ล้างข้อมูล'
    },
    "back" : {
        variant: 'secondary',
        icon: 'fa-classic fa-light fa-circle-arrow-left fa-fw',
        label: ''
    }, 
    "back-to-login" : {
        variant: 'warning',
        icon: 'fa-classic fa-light fa-circle-arrow-left fa-fw',
        label: 'กลับไปหน้าเข้าสู่ระบบ'
    },    
    "discard-no-text" : {
        variant: 'secondary',
        icon: 'fa-classic fa-light fa-xmark fa-fw',
        label: ''
    },
    "delete-no-text" : {
        variant: 'danger',
        icon: 'fa-classic fa-light fa-eraser fa-fw',
        label: '',
    },        
    "confirm" : {
        variant: 'danger',
        icon: 'fa-classic fa-light fa-trash-check fa-fw',
        label: 'ยืนยัน'
    },
    "search" : {
        variant: 'primary',
        icon: 'fa-classic fa-light fa-magnifying-glass fa-fw',
        label: ''
    },
    "edit" : {
        variant: '',
        icon: 'fa-classic fa-light fa-pen fa-fw',
        label: ''
    },
    "print" : {
        variant: 'primary',
        icon: 'fa-classic fa-light fa-print fa-fw',
        label: 'พิมพ์เอกสาร'
    },  
    "open-content" : {
        variant: '',
        icon: 'fa-classic fa-solid fa-play fa-fw',
        label: ''
    },        
    "up-direction" : {
        variant: '',
        icon: 'fa-classic fa-light fa-circle-chevron-up fa-fw',
        label: ''
    },
    "down-direction" : {
        variant: '',
        icon: 'fa-classic fa-light fa-circle-chevron-down fa-fw',
        label: ''
    },
    "preview-file" : {
        variant: 'outline-primary',
        icon: 'fa-classic fa-light fa-eye fa-fw',
        label: 'ดูไฟล์แนบ',
    },
    "delete-file" : {
        variant: 'outline-danger',
        icon: 'fa-classic fa-light fa-eraser fa-fw',
        label: 'ลบไฟล์แนบ',
    },
    "confirm-delete-file" : {
        variant: 'danger',
        icon: 'fa-classic fa-light fa-trash-can-check fa-fw',
        label: '',
    },
    "discard-delete-file" : {
        variant: 'secondary',
        icon: 'fa-classic fa-light fa-clock-rotate-left fa-fw',
        label: '',
    },
    "configuration" : {
        variant: '',
        icon: 'fa-classic fa-light fa-gear-complex fa-fw',
        label: ''
    },
    "download" : {
        variant: 'primary',
        icon: 'fa-classic fa-light fa-cloud-arrow-down fa-fw',
        label: 'ดาวน์โหลด'
    },
    "sent-data": {
        variant: 'primary',
        icon: 'fa-classic fa-light fa-paper-plane-top',
        label: 'รีเซ็ตรหัสผ่าน'
    }
}

/** handle alert properties */
export const AlertProps = {
    "new-success" : {
        variant: 'success',
        key: 'dark',
        icon: 'fa-classic fa-light fa-circle-check fa-fw',
        title: 'บันทึกข้อมูลเรียบร้อย',
        message: '',
        dismiss: true,
        autoHide: true
    },
    "new-error" : {
        variant: 'danger',
        key: 'dark',
        icon: 'fa-classic fa-light fa-circle-exclamation fa-fw',
        title: 'เกิดข้อผิดพลาดในการบันทึกข้อมูล',
        message: '',
        dismiss: true,
        autoHide: true
    },
    "new-duplicate" : {
        variant: 'danger',
        key: 'dark',
        icon: 'fa-classic fa-light fa-clone fa-fw',
        title: 'ข้อมูลซ้ำซ้อน',
        message: '',
        dismiss: true,
        autoHide: false
    },
    "update-success" : {
        variant: 'success',
        key: 'dark',
        icon: 'fa-classic fa-light fa-circle-check fa-fw',
        title: 'ปรับปรุงข้อมูลเรียบร้อย',
        message: '',
        dismiss: true,
        autoHide: true
    },
    "update-error" : {
        variant: 'danger',
        key: 'dark',
        icon: 'fa-classic fa-light fa-circle-exclamation fa-fw',
        title: 'เกิดข้อผิดพลาดในการปรับปรุงข้อมูล',
        message: '',
        dismiss: true,
        autoHide: true
    },
    "delete-success" : {
        variant: 'warning',
        key: 'dark',
        icon: 'fa-classic fa-light fa-trash-check fa-fw',
        title: 'ลบข้อมูลเรียบร้อย',
        message: '',
        dismiss: true,
        autoHide: true
    },
    "delete-error" : {
        variant: 'danger',
        key: 'dark',
        icon: 'fa-classic fa-light fa-circle-exclamation fa-fw',
        title: 'เกิดข้อผิดพลาดในการลบข้อมูล',
        message: '',
        dismiss: true,
        autoHide: true
    },
    "preview-file-error" : {
        variant: 'danger',
        key: 'dark',
        icon: 'fa-classic fa-light fa-circle-exclamation fa-fw',
        title: 'เกิดข้อผิดพลาดในการเปิดไฟล์แนบ',
        message: '',
        dismiss: true,
        autoHide: true
    },
}

/** handle alert properties */
export const ToastProps = {
    "update-success" : {
        variant: 'success',
        icon: 'fa-classic fa-light fa-circle-check fa-fw',
        title: 'ปรับปรุงข้อมเูลเรียบร้อย',
        dismiss: true,
    },
    "update-fail" : {
        variant: 'warning',
        icon: 'fa-classic fa-light fa-circle-question fa-fw',
        title: 'ปรับปรุงข้อมเูลเรียบร้อย',
        dismiss: true,
    },
    "update-error" : {
        variant: 'danger',
        icon: 'fa-classic fa-light fa-circle-exclamation fa-fw',
        title: 'ปรับปรุงข้อมเูลเรียบร้อย',
        dismiss: true,
    },
    "fetch-edit-fail" : {
        variant: 'warning',
        icon: 'fa-classic fa-light fa-circle-question fa-fw',
        title: 'ไม่พบข้อมูลที่ต้องการแก้ไข',
        dismiss: true,
    },
    "fetch-edit-error" : {
        variant: 'danger',
        icon: 'fa-classic fa-light fa-circle-exclamation fa-fw',
        title: 'เกิดปัญหาในการอ่านข้อมูล',
        dismiss: true,
    },
    "delete-success" : {
        variant: 'danger',
        icon: 'fa-classic fa-light fa-trash-check fa-fw',
        title: 'ลบข้อมูลเรียบร้อย',
        dismiss: true,
    },
    "delete-fail" : {
        variant: 'warning',
        icon: 'fa-classic fa-light fa-circle-question fa-fw',
        title: 'ไม่สามารถทำการลบข้อมูล',
        dismiss: true,
    },
    "delete-error" : {
        variant: 'danger',
        icon: 'fa-classic fa-light fa-circle-exclamation fa-fw',
        title: 'เกิดปัญหาในการลบข้อมูล',
        dismiss: true,
    },
    "reorder-success" : {
        variant: 'info',
        icon: 'fa-classic fa-light fa-bars-sort fa-fw',
        title: 'จัดเรียงข้อมูลเรียบร้อย',
        dismiss: true,
    },
    "reorder-fail" : {
        variant: 'warning',
        icon: 'fa-classic fa-light fa-circle-question fa-fw',
        title: 'ไม่สามารถจัดเรียงข้อมูล',
        dismiss: true,
    },
    "reorder-error" : {
        variant: 'danger',
        icon: 'fa-classic fa-light fa-circle-exclamation fa-fw',
        title: 'เกิดปัญหาในการจัดเรียงข้อมูล',
        dismiss: true,
    },
}

/** handle confirm modal properties */
export const ModalProps = {
    "confirm-delete" : {
        title: "ต้องการลบข้อมูล",
        message: "ยืนยันการลบข้อมูล",
        confirmButton: 'confirm',
        discard: false,
        size: 'sm',
        dismiss: false
    }
}

/** handle sidebar menu */
export const SidebarMenu = [
    {
        group: '',
        contents: [
            {
                name: 'Dashboard',
                icon: 'fa-classic fa-light fa-gauge fa-fw',
                path: prefixApps + 'dashboard',
            }
        ]
    },
    {
        group: 'Apps',
        contents: [
            {
                id: 'graduate',
                name: 'EEC Model Type A',
                icon: 'fa-classic fa-light fa-users-between-lines fa-fw',
                path: '',
                allowPermits: ["displayTypeA"],
                childrens: [
                    {
                        name: 'ข้อมูลนักศึกษา ทวิภาคี',
                        path: prefixApps + 'type-a-duol-coop',
                        grp_name: 'graduate',
                        allowPermits: ["eec_model_type_a_student"],
                    },
                    {
                        name: 'ข้อมูลนักศึกษา 100%',
                        path: prefixApps + 'type-a-student',
                        grp_name: 'graduate',
                        allowPermits: ["eec_model_type_a_student"],
                    },
                    {
                        name: 'นำเข้าไฟล์ Type A ทวิภาคี',
                        // path: prefixApps + 'type-a-student-import-file',
                        // grp_name: 'graduate',
                        allowPermits: ["eec_model_type_a_import"],
                    },
                    {
                        name: '- นักศึกษาใหม่',
                        path: prefixApps + 'type-a-statistic-new-student-import-file',
                        grp_name: 'statistic-new',
                        allowPermits: ["eec_model_type_a_import"],
                    },
                    {
                        name: '- ผู้สำเร็จการศึกษา',
                        path: prefixApps + 'type-a-statistic-grad-student-import-file',
                        grp_name: 'statistic-graduate',
                        allowPermits: ["eec_model_type_a_import"],
                    },
                    {
                        name: 'นำเข้าไฟล์ Type A 100%',
                        // path: prefixApps + 'type-a-student-import-file',
                        // grp_name: 'graduate',
                        allowPermits: ["eec_model_type_a_import"],
                    },
                    {
                        name: '- นักศึกษาใหม่ ',
                        path: prefixApps + 'type-a-100-new-student-import-file',
                        grp_name: '100-new',
                        allowPermits: ["eec_model_type_a_import"],
                    },
                    {
                        name: '- ผู้สำเร็จการศึกษา ',
                        path: prefixApps + 'type-a-100-grad-student-import-file',
                        grp_name: '100-graduate',
                        allowPermits: ["eec_model_type_a_import"],
                    },
                ]
            },
            
            {
                id: 'courses',
                name: 'EEC Model Type B',
                icon: 'fa-classic fa-light fa-screen-users fa-fw',
                path: '',
                allowPermits: ["displayTypeB"],
                childrens: [
                    /** 
                    {
                        name: 'หลักสูตร',
                        path: prefixApps + 'eb01-course-list',
                        grp_name: 'courses'
                    },
                    */
                    // {
                    //     name: 'นำเข้าหลักสูตร Type B',
                    //     path: prefixApps + 'eb-import-course',
                    //     grp_name: 'courses',
                    //     // allowPermits: ["eec_model_type_b_eb1"],
                    // },
                    {
                        name: 'ขอพิจารณารับรองหลักสูตร (EB01)',
                        path: prefixApps + 'eb01-course',
                        grp_name: 'courses',
                        allowPermits: ["eec_model_type_b_eb1"],
                    },
                    {
                        name: 'ขออนุมัติจัดอบรม (EB02)',
                        path: prefixApps + 'eb02-course',
                        grp_name: 'courses',
                        allowPermits: ["eec_model_type_b_eb2"],
                    },
                    {
                        name: 'รายงานผลการจัดอบรม (EB03)',
                        path: prefixApps + 'eb03-course',
                        grp_name: 'courses',
                        allowPermits: ["eec_model_type_b_eb3"],
                    },
                    {
                        name: 'ผลการอบรม (EB04)',
                        path: prefixApps + 'eb04-course',
                        grp_name: 'courses',
                        allowPermits: ["eec_model_type_b_eb3"],
                    },
                ]
            },
            {
                id: 'demandSupply',
                name: 'ความต้องการกำลังคน',
                icon: 'fa-classic fa-light fa-people-arrows fa-fw',
                path: '',
                allowPermits: ["displayDemand"],
                childrens: [
                    {
                        name: 'ความต้องการกำลังคน',
                        path: prefixApps + 'demand-manpower',
                        grp_name: 'demandSupply',
                        allowPermits: ["demand_supply_manpower"],
                    },
                    {
                        name: 'ผลผลิตกำลังคน',
                        path: prefixApps + 'supply-human-resource',
                        grp_name: 'demandSupply',
                        allowPermits: ["demand_supply_resource"],
                    },
                    {
                        name: 'จับคู่ความต้องการกำลังคน',
                        path: prefixApps + 'matching-demand-supply',
                        grp_name: 'demandSupply',
                        allowPermits: ["demand_supply_matching"],
                    },
                ]
            },
            {
                id: 'information',
                name: 'ประชาสัมพันธ์',
                icon: 'fa-classic fa-light fa-bullhorn fa-fw',
                path: '',
                allowPermits: ["displayPublicize"],
                childrens: [
                    {
                        name: 'ข่าวสาร',
                        path: prefixApps + 'public-data-publicize-news',
                        grp_name: 'information',
                        allowPermits: ["publicize_news"],
                    },
                    {
                        name: 'สถาบันและหลักสูตร',
                        path: prefixApps + 'public-data-publicize-academy-and-course',
                        grp_name: 'information',
                        allowPermits: ["publicize_academy_and_course"],
                    },
                    {
                        name: 'ประชาสัมพันธ์ตำแหน่งงาน',
                        path: prefixApps + 'public-data-publicize-vacancies',
                        grp_name: 'information',
                        allowPermits: ["publicize_vacancies"],
                    },
                    /** 
                    {
                        name: 'ข้อมูลข่าวสาร',
                        path: prefixApps + 'public-data-publicize-news-list',
                        grp_name: 'information',
                    },
                    {
                        name: 'ข้อมูลสถาบันและหลักสูตร',
                        path: prefixApps + 'public-data-publicize-academy-and-course-list',
                        grp_name: 'information',
                    },
                    {
                        name: 'ข้อมูลประชาสัมพันธ์ตำแหน่งงาน',
                        path: prefixApps + 'public-data-publicize-vacancies-list',
                        grp_name: 'information',
                    },
                    */
                ]
            },
            {
                id: 'eec-nets-data',
                name: 'ศูนย์เครือข่าย',
                icon: 'fa-classic fa-light fa-chart-network fa-fw',
                path: prefixApps + 'eec-nets-data',
                allowPermits: ["eec_nets"],
            },
            {
                id: 'users',
                name: 'ผู้ใช้และระดับสิทธิ์',
                icon: 'fa-classic fa-light fa-user-shield fa-fw',
                path: '',
                allowPermits: ["displayUsers"],
                childrens: [
                    {
                        name: 'ผู้ประกอบการ',
                        path: prefixApps + 'common-data-enterprise',
                        grp_name: 'users',
                        allowPermits: ["enterprise"],
                    },
                    {
                        name: 'สถานศึกษา',
                        path: prefixApps + 'common-data-academy',
                        grp_name: 'users',
                        allowPermits: ["academy"],
                    },
                    {
                        name: 'ผู้ใช้งานภายนอก',
                        path: prefixApps + 'user-data-external-user',
                        grp_name: 'users',
                        allowPermits: ["external_user"],
                    },
                    {
                        name: 'ผู้ใช้งาน',
                        path: prefixApps + 'user-data-user',
                        grp_name: 'users',
                        allowPermits: ["users"],
                    },
                    {
                        name: 'สิทธิ์การเข้าใช้งาน',
                        path: prefixApps + 'user-data-permission',
                        grp_name: 'users',
                        allowPermits: ["permission"],
                    },
                ]
            },
            {
                id: 'masterData',
                name: 'ข้อมูลพื้นฐาน',
                icon: 'fa-classic fa-light fa-database fa-fw',
                path: '',
                allowPermits: ["master_data"],
                childrens: [
                    /** 
                    {
                        name: 'Prototype Template',
                        path: prefixApps + 'prototype-template',
                        grp_name: 'masterData',
                    },
                    */
                    {
                        name: 'พื้นที่',
                        path: prefixApps + 'master-data-region',
                        grp_name: 'masterData',
                        allowPermits:["master_data"],
                    },
                    {
                        name: 'คำนำหน้าชื่อ',
                        path: prefixApps + 'master-data-prefix-name',
                        grp_name: 'masterData',
                        allowPermits:["master_data"],
                    },
                    {
                        name: 'ตำแหน่ง',
                        path: prefixApps + 'master-data-position',
                        grp_name: 'masterData',
                        allowPermits:["master_data_position"],
                    },
                    {
                        name: 'อุตสาหกรรมเป้าหมาย',
                        path: prefixApps + 'master-data-target-industries',
                        grp_name: 'masterData',
                        allowPermits:["master_data"],
                    },
                    {
                        name: 'ทักษะ Skills Set',
                        path: prefixApps + 'common-data-skills-set-type',
                        grp_name: 'commonData',
                        allowPermits:["master_data"],
                    },
                    {
                        name: 'Cluster Skills Set',
                        path: prefixApps + 'common-data-skills-set-cluster',
                        grp_name: 'commonData',
                        allowPermits:["master_data"],
                    },
                    {
                        name: 'หมวดค่าใช้จ่าย',
                        path: prefixApps + 'master-data-expense-category',
                        grp_name: 'masterData',
                        allowPermits:["master_data_expense"],
                    },
                    {
                        name: 'สวัสดิการ',
                        path: prefixApps + 'master-data-welfare',
                        grp_name: 'masterData',
                        allowPermits:["master_data"],
                    },
                    {
                        name: 'สิทธิประโยชน์',
                        path: prefixApps + 'master-data-benefits',
                        grp_name: 'masterData',
                        allowPermits:["master_data"],
                    },
                    {
                        name: 'ประเภทสถานศึกษา',
                        path: prefixApps + 'master-data-education-type',
                        grp_name: 'masterData',
                        allowPermits:["master_data"],
                    },
                    {
                        name: 'ระดับการศึกษา',
                        path: prefixApps + 'master-data-education-level',
                        grp_name: 'masterData',
                        allowPermits:["master_data"],
                    },
                    {
                        name: 'โครงสร้างหลักสูตร',
                        path: prefixApps + 'master-data-faculty',
                        grp_name: 'masterData',
                        allowPermits:["master_data"],
                    },
                    {
                        name: 'เขตพื้นที่การศึกษา',
                        path: prefixApps + 'master-data-education-area',
                        grp_name: 'masterData',
                        allowPermits:["master_data"],
                    },
                    {
                        name: 'โครงสร้างหน่วยงาน',
                        path: prefixApps + 'master-data-ministry',
                        grp_name: 'masterData',
                        allowPermits:["master_data"],
                    },
                ]
            },
            // {
            //     id: 'reports',
            //     name: 'รายงาน',
            //     icon: 'fa-classic fa-light fa-paper-plane fa-fw',
            //     path: '',
            //     childrens: [
            //         {
            //             name: '',
            //             path: '',
            //             grp_name: 'reports'
            //         },
            //         {
            //             name: 'แบบประเมินความพึงพอใจ',
            //             path: prefixApps + '',
            //             grp_name: 'reports'
            //         },
            //     ]
            // },
        ]
    }
];
